import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCooneyBrothers/Handlers/CustomHandlerCreator";

type HandlerType = CustomHandler<{ accountNumber: string }>;

export const DispatchSetAccountNumber: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/SetAccountNumber",
        accountNumber: props.parameter.accountNumber,
    });
};

export const chain = [DispatchSetAccountNumber];

const setAccountNumber = createHandlerChainRunner(chain, "SetAccountNumber");
export default setAccountNumber;
